<ng-container *ngIf="(utilsService.loader$ | async) || (utilsService.navigationLoader$ | async) || (utilsService.forceLoader$ | async)">
    <div class="demon-mask show">
        <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <span class="sr-only">Caricamento...</span>
        </div>
    </div>
    <div class="demon-mask-backdrop show"></div>
</ng-container>
